import React, { useEffect, useState, useRef } from 'react';
 import DistExtensionReportafso from './DistExtensionReportafso';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']; 

const DistributionExtensionDist_data = async (params) => { 

    const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/api/DistExtensionReport`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};


const Distribution_Dist = ({ month, year}) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsRRef = useRef(null); // Use ref to scroll to this div

    const handleDistClick = (month, year, dist_code) => {
        setRenderContentt(null);
           
        setTimeout(() => {
            setRenderContentt(
                <DistExtensionReportafso month={month} year={year}  dist_code={dist_code}/>
            );
        }, 10);

  
        };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await DistributionExtensionDist_data({ month, year });
                 setTabHeading(response_data.heading);
                if (response_data.data && response_data.data.length > 0) {
                
                    setReportData(response_data.data);
                } else {
                    setReportData("No data found ");    
                }
                
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year ]);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth' , block: 'center'});
        }
    }, [loading, error, reportData]);

    
    if (loading) {
        return <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
            <CircularProgress />
        </Box></div>
    }
    if (error) {
        return <div class="mainhead" align="center">
        Internal Error
        </div>
    }

    if (!reportData || !Array.isArray(reportData) || reportData.length === 0) {
    return <div className="mainhead" align="center">
        No data found
    </div>
}
    return (
        <> 
            <table  id="myTable" align="center" width="50%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={9}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={3}>Sl.No</th>
                        <th rowSpan={3}>District</th> 
                        <th rowSpan={3}>Start Date </th>
                        <th rowSpan={3}>End Date</th>
                    </tr>
                    
                </thead>
                <tbody>
                    { 
                        reportData.map((item, index) => (
                            <tr key={item.dist_code}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ textAlign: 'left' }}>
                                    <a
                                        style={{ cursor: 'pointer', color: 'blue' }}
                                        onClick={() => handleDistClick(month, year, item.dist_code, tabHeading)}
                                    >
                                        {item.dist_name_en}
                                    </a>
                                </td>
                                 <td style={{ textAlign: 'right' }}>{item.startdate}</td>
                                <td style={{ textAlign: 'right' }}>{item.endDate}</td>
                            </tr>
                        ))
                     }
                       
                    
                </tbody>
            </table>
           
            <br /><br />
            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
        </>
    );
};

export default Distribution_Dist;
